<template>
  <div id="q-app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  meta() {
    const metas = this.$store.state?.auth?.config?.branding?.metas;
    return metas;
  },
};
</script>
<style>
@import "css/sandals/sandals-icons.css";
</style>
